import './meter.scss';

import React from 'react';
import View from 'components/ui/view';
import Text from 'components/ui/text';

function FreeShippingMeter({ subtotal }) {
  const threshold = 75;
  const diff = (threshold - subtotal).toFixed(2);
  const success = diff <= 0;
  const percentage = success ? 100 : subtotal / threshold * 100;
  const width = `${percentage}%`;

  return (
    <View
      className="text-center"
      padding={{ top: 'sm', sides: 'sm', bottom: 'xs' }}
    >
      {success ? (
        <Text weight="bold">Congrats, you{"'"}ve unlocked FREE shipping!</Text>
      ) : (
        <Text weight="bold">${diff} away from FREE shipping</Text>
      )}
      <View padding="xs">
        <Text weight="bold" className="inline-block">
          $0
        </Text>
        <div className="meter inline-block">
          <div className="meter__bar" style={{ width }} />
        </div>
        <Text weight="bold" className="inline-block">
          ${threshold}
        </Text>
      </View>
    </View>
  );
}

export default FreeShippingMeter;



// WEBPACK FOOTER //
// ./shared/components/cart/freeShippingMeter.js